import { Col, Form } from 'react-bootstrap'
import { toast } from 'react-toastify'

import hocFrom from '../../../components/forms/HocFrom'
import InputFarsi from '../../../components/inputs/InputFarsi'
import Switchrs from '../../../components/inputs/Switchrs'
import Loader from '../../../components/layout/Loader'

const FromPrefix = ({ handelUpdataFrom,
    handelSend, loding, handelLoadingform, LoadingForm,
    dataUpdate, handelsetdataForm, formdata }) => {

    const handelValue = (name, value) => {
        switch (name) {
            case 'name':
                handelsetdataForm({ ...formdata, name: value })
                break;
            case 'isActiveFromPrefix':
                handelsetdataForm({ ...formdata, isActive: value })
                break;
            default:
                break;
        }
    }
    const handelSubmit = event => {
        event.preventDefault()

        handelLoadingform(true)
        if (!formdata.name) {
            toast.error("لطفا نام   را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else {
            dataUpdate.name ? handelUpdataFrom() : handelSend()
        }
    }

    return (
        <>
            {
                loding ?
                    <Loader />
                    :
                    <Form>
                        <Form.Row>
                            <Col>
                                <InputFarsi label='پیشوند' name='name' defaultValue={dataUpdate.name} handelValue={handelValue} />
                            </Col>
                            <Switchrs label="آیا فعال باشد؟" name='isActiveFromPrefix' checke={formdata.isActive} handelValue={handelValue} />
                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <button type='submit'
                                    className='btn btn-success'
                                    onClick={handelSubmit}
                                    disabled={LoadingForm} >
                                    {LoadingForm ?
                                        <i className="fa fa-spinner fa-pulse fa-fw"></i>
                                        : dataUpdate.name ? "ثبت ویرایش" : "ثبت"}
                                </button>
                            </Col>
                        </Form.Row>
                    </Form>
            }
        </>
    )
}

export default hocFrom(FromPrefix)